import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { warning } from '../../../../../components/Alert/Alert';
import Input from '../../../../../components/Input/Input';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { conversionLabel } from '../../../../conversion';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { selectProject } from '../../../selector/conversion';
import { setHydraulicData } from '../../../store/project/projectSlice';
import { cleanResults } from '../../../store/project/resultsSlice';
import { IHydraulicDataProps, IHydraulicDataVerticalDropForm } from './IHydraulicData';

const HydraulicDataVerticalDrop = (props: IHydraulicDataProps) => {
    let timer = useRef<NodeJS.Timeout | null>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);

    const defaultValue: IHydraulicDataVerticalDropForm = {
        discharge: (project.data?.hydraulicData as IHydraulicDataVerticalDropForm)?.discharge,
        riverBedGradient: (project.data?.hydraulicData as IHydraulicDataVerticalDropForm)?.riverBedGradient,
        roughnessCoefficient: (project.data?.hydraulicData as IHydraulicDataVerticalDropForm)?.roughnessCoefficient,
        id: project.data?.hydraulicData?.id,
    };

    const [form, setForm] = useState<IHydraulicDataVerticalDropForm>(defaultValue);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let name = e.target.name;
        let value = parseFloat(e.target.value);

        if (value < 0) {
            value = 0;
            warning(t('warning_not_be_lower', { value: 0 }));
        }

        setForm({
            ...form!,
            [name]: value,
        });
    };

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            dispatch(cleanResults());
            dispatch(setHydraulicData(form as IHydraulicDataVerticalDropForm));
        }, 1000);
    }, [form]);

    return (
        <div className='d-flex flex-column gap-2'>
            <Input
                type='number'
                title={t('input_discharge', { unit_measure: conversionLabel.m3s_ft3s[projectInfo.data?.unitOfMeasure as number] })}
                defaultValue={form.discharge}
                name='discharge'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_riverBedGradient', { unit_measure: 'm/m' })}
                defaultValue={form.riverBedGradient}
                name='riverBedGradient'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_roughnessCoefficient')}
                defaultValue={form.roughnessCoefficient}
                name='roughnessCoefficient'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
        </div>
    );
};

export default HydraulicDataVerticalDrop;
